module.exports = __webpack_public_path__ + "img/emissionRegisterIcon_active.48742e6f.svg";